"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateTime = void 0;
const tslib_1 = require("tslib");
const webapi_1 = require("@fegobull/webapi");
const dayjs_1 = tslib_1.__importDefault(require("dayjs"));
const vue_demi_1 = require("vue-demi");
const useI18n_1 = require("../common/useI18n");
const useUpdateTime = (props) => {
    const data = webapi_1.use.useVariable();
    // 设置为当前整点时间 2025/02/10 19:00更新
    (0, vue_demi_1.onMounted)(async () => {
        const now = (0, dayjs_1.default)();
        let updateTime = '';
        if (props.language_id === useI18n_1.LanguageId.SC) {
            updateTime = now.format('YYYY/MM/DD HH:00');
        }
        else if (props.language_id === useI18n_1.LanguageId.EN) {
            updateTime = now.format('DD/MM/YYYY HH:00');
        }
        data.updateTime = updateTime;
    });
};
exports.useUpdateTime = useUpdateTime;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlVXBkYXRlVGltZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInVzZVVwZGF0ZVRpbWUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7OztBQUFBLDZDQUF1QztBQUN2QywwREFBMEI7QUFDMUIsdUNBQXFDO0FBQ3JDLCtDQUErQztBQUV4QyxNQUFNLGFBQWEsR0FBRyxDQUFDLEtBQUssRUFBRSxFQUFFO0lBQ25DLE1BQU0sSUFBSSxHQUFHLFlBQUcsQ0FBQyxXQUFXLEVBQUUsQ0FBQztJQUUvQiwrQkFBK0I7SUFDL0IsSUFBQSxvQkFBUyxFQUFDLEtBQUssSUFBSSxFQUFFO1FBQ2pCLE1BQU0sR0FBRyxHQUFHLElBQUEsZUFBSyxHQUFFLENBQUM7UUFDcEIsSUFBSSxVQUFVLEdBQUcsRUFBRSxDQUFDO1FBQ3BCLElBQUksS0FBSyxDQUFDLFdBQVcsS0FBSyxvQkFBVSxDQUFDLEVBQUUsRUFBRSxDQUFDO1lBQ3RDLFVBQVUsR0FBRyxHQUFHLENBQUMsTUFBTSxDQUFDLGtCQUFrQixDQUFDLENBQUM7UUFDaEQsQ0FBQzthQUFNLElBQUksS0FBSyxDQUFDLFdBQVcsS0FBSyxvQkFBVSxDQUFDLEVBQUUsRUFBRSxDQUFDO1lBQzdDLFVBQVUsR0FBRyxHQUFHLENBQUMsTUFBTSxDQUFDLGtCQUFrQixDQUFDLENBQUM7UUFDaEQsQ0FBQztRQUNELElBQUksQ0FBQyxVQUFVLEdBQUcsVUFBVSxDQUFDO0lBQ2pDLENBQUMsQ0FBQyxDQUFDO0FBQ1AsQ0FBQyxDQUFDO0FBZFcsUUFBQSxhQUFhLGlCQWN4QiJ9